import React from "react";
import { Modal } from "../../../../../../../components/core/Modal/Modal";
import {
  CANCEL_LABEL,
  CONFIRM_LABEL,
} from "../../../../../../../constants/Dictionary";
import {
  Button,
  ButtonVariants,
} from "../../../../../../../components/core/Button/Button";
import { BodyTyp } from "../../../../../../../components/Typography/Typography";
import { ReactComponent as CheckIcon } from "../../../../../../../icons/check.svg";
import { ReactComponent as CloseIcon } from "../../../../../../../icons/close.svg";
import { FontWeightEnum } from "../../../../../../../types/AppTypes";

interface ModalDeleteGradesProps {
  modalLabel: string;
  title: string;
  isOpen: boolean;
  closeModal: () => void;
  deleteItem: () => void;
}

export const ModalDeleteItem = ({
  modalLabel,
  title,
  isOpen,
  closeModal,
  deleteItem,
}: ModalDeleteGradesProps) => {
  function handleDeleteGrade() {
    closeModal();
    deleteItem();
  }

  return (
    <Modal
      label={title}
      fullSize={false}
      isOpen={isOpen}
      closeModal={closeModal}
      leftButton={
        <Button
          icon={<CloseIcon />}
          label={CANCEL_LABEL}
          onClick={() => closeModal()}
          variant={ButtonVariants.SECONDARY}
        />
      }
      rightButton={
        <Button
          icon={<CheckIcon />}
          label={CONFIRM_LABEL}
          onClick={() => handleDeleteGrade()}
        />
      }
    >
      <BodyTyp fontWeight={FontWeightEnum.MEDIUM} variant="2">
        {modalLabel}
      </BodyTyp>
    </Modal>
  );
};
